'use strict';

const SELECTOR = '.js-form';

function decodeHtmlEntities(str) {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = str;
    return textarea.value;
}

export default function init() {
    const forms = document.querySelectorAll(SELECTOR);

    if (!forms.length) {
        return;
    }

    const search = new URLSearchParams(window.location.search);

    if (search.has('form_message')) {
        const message = decodeHtmlEntities(search.get('form_message'));

        forms.forEach(form => {
            const formBody = form.querySelector('.form__body');

            formBody.querySelectorAll('.form__fields-wrapper, .form__submit-wrapper').forEach(el => el.remove());

            const messageEl = document.createElement('div');
            messageEl.classList.add('form__message');
            messageEl.textContent = message;

            formBody.appendChild(messageEl);
            form.scrollIntoView({ behavior: 'smooth' });
        });
    }
}
